import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [   
  {
    path: 'members',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  /*{
    path: '',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },*/
  {
    path: '',
    loadChildren: () => import('./lobby/lobby.module').then( m => m.LobbyPageModule)
  },
  {
	path: 'members/professionals-list',
	loadChildren: () => import('./professionals-list/professionals-list.module').then( m => m.ProfessionalsListPageModule)
  },{
    path: 'members/conference-list',
    loadChildren: () => import('./conference-list/conference-list.module').then( m => m.ConferenceListPageModule)
  },
  {
    path: 'members/conference',
    loadChildren: () => import('./conference/conference.module').then( m => m.ConferencePageModule)
  },
  {
    path: 'members/professionals-list/calendar',
    loadChildren: () => import('./calendar/calendar.module').then( m => m.CalendarPageModule)
  },
  {
    path: 'members/tickets',
    loadChildren: () => import('./help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'members/tickets/tickets-add',
    loadChildren: () => import('./help-add/help-add.module').then( m => m.HelpAddPageModule)
  },
  {
    path: 'members/conversation',
    loadChildren: () => import('./conversation/conversation.module').then( m => m.ConversationPageModule)
  },
  {
    path: 'members/event-list',
    loadChildren: () => import('./event-list/event-list.module').then( m => m.EventListPageModule)
  },
  {
    path: 'members/bulletin',
    loadChildren: () => import('./bulletin/bulletin.module').then( m => m.BulletinPageModule)
  },
  {
    path: 'members/bulletin/bulletin-view',
    loadChildren: () => import('./bulletin-view/bulletin-view.module').then( m => m.BulletinViewPageModule)
  },
  {
    path: 'members/challenge',
    loadChildren: () => import('./challenge/challenge.module').then( m => m.ChallengePageModule)
  },
  {
    path: 'members/profile',
    loadChildren: () => import('./profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'members/rate',
    loadChildren: () => import('./rate/rate.module').then( m => m.RatePageModule)
  },   {
    path: 'members/residents',
    loadChildren: () => import('./residents/residents.module').then( m => m.ResidentsPageModule)
  },
  {
    path: 'members/residents-add',
    loadChildren: () => import('./residents-add/residents-add.module').then( m => m.ResidentsAddPageModule)
  },
  {
    path: 'members/administration',
    loadChildren: () => import('./administration/administration.module').then( m => m.AdministrationPageModule)
  },
  {
    path: 'members/residents-edit',
    loadChildren: () => import('./residents-edit/residents-edit.module').then( m => m.ResidentsEditPageModule)
  },
  {
    path: 'members/reservation',
    loadChildren: () => import('./reservation/reservation.module').then( m => m.ReservationPageModule)
  },
  {
    path: 'members/reservation/reservation-add',
    loadChildren: () => import('./reservation-add/reservation-add.module').then( m => m.ReservationAddPageModule)
  },
  {
    path: 'members/reservation/reservation-view',
    loadChildren: () => import('./reservation-view/reservation-view.module').then( m => m.ReservationViewPageModule)
  },
  {
    path: 'members/reservation/reservation-guest',
    loadChildren: () => import('./reservation-guest/reservation-guest.module').then( m => m.ReservationGuestPageModule)
  },
  {
    path: 'members/reservation/reservation-guest/reservation-guest-add',
    loadChildren: () => import('./reservation-guest-add/reservation-guest-add.module').then( m => m.ReservationGuestAddPageModule)
  },
  {
    path: 'qr-scan',
    loadChildren: () => import('./qr-scan/qr-scan.module').then( m => m.QrScanPageModule)
  },
  {
    path: 'members/reservation/reservation-guest/reservation-guest-add-massive',
    loadChildren: () => import('./reservation-guest-add-massive/reservation-guest-add-massive.module').then( m => m.ReservationGuestAddMassivePageModule)
  },
  {
    path: 'members/reservation/reservation-guest/reservation-guest',
    loadChildren: () => import('./reservation-guest/reservation-guest.module').then( m => m.ReservationGuestPageModule)
  },
  {
    path: 'members/myAccount',
    loadChildren: () => import('./myAccount/myAccount.module').then( m => m.MyAccountPageModule)
  },
  {
    path: 'members/reportPayment',
    loadChildren: () => import('./reportPayment/reportPayment.module').then( m => m.ReportPaymentPageModule)
  },
  {
    path: 'members/reportPayment/reportPayment-add',
    loadChildren: () => import('./reportPayment-add/reportPayment-add.module').then( m => m.ReportPaymentAddPageModule)
  },
  {
    path: 'lobby',
    loadChildren: () => import('./lobby/lobby.module').then( m => m.LobbyPageModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./agent/agent.module').then( m => m.AgentPageModule),
    data: { animated: false }
  }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
